import { BaseIcon } from './base';
import type { IconProps } from './base';

export function FiftyLogo(props: IconProps) {
  return (
    <BaseIcon viewBox="0 0 346 80" {...props}>
      <path
        d="M312.077 54.0756L316.901 49.7053C319.966 53.6783 324.166 55.381 329.444 55.381C334.155 55.381 337.334 54.3026 337.334 51.7486C337.334 49.1378 334.78 49.081 327.685 48.2297C319.909 47.2648 314.007 45.9594 314.007 39.6594C314.007 34.0405 319.455 30.0107 328.082 30.0107C335.234 30.0107 340.796 32.7351 343.35 36.1405L338.98 40.3405C336.766 37.3891 332.736 35.6297 327.798 35.6297C322.861 35.6297 320.534 36.9918 320.534 39.0351C320.534 41.1351 322.747 41.4188 329.274 42.2134C337.277 43.1783 344.031 44.1432 344.031 51.0675C344.031 57.7648 337.05 60.9999 329.501 60.9999C321.896 60.9999 315.369 58.5026 312.077 54.0756Z"
        fill="currentColor"
      />
      <path d="M308.994 19.6243V60.3756H302.183V19.6243H308.994Z" fill="currentColor" />
      <path d="M295.58 19.6243V60.3756H288.769V19.6243H295.58Z" fill="currentColor" />
      <path
        d="M275.243 26.6053V19.6243H282.28V26.6053H275.243ZM282.167 30.5783V60.3756H275.356V30.5783H282.167Z"
        fill="currentColor"
      />
      <path
        d="M245.142 19.6243V45.5053L262.793 30.5783H272.329L256.493 43.6324L272.953 60.3756H264.212L251.612 47.6621L245.142 52.9972V60.3756H238.331V19.6243H245.142Z"
        fill="currentColor"
      />
      <path
        d="M202.222 54.0756L207.046 49.7053C210.111 53.6783 214.311 55.381 219.589 55.381C224.3 55.381 227.478 54.3026 227.478 51.7486C227.478 49.1378 224.924 49.081 217.83 48.2297C210.054 47.2648 204.151 45.9594 204.151 39.6594C204.151 34.0405 209.6 30.0107 218.227 30.0107C225.378 30.0107 230.941 32.7351 233.495 36.1405L229.124 40.3405C226.911 37.3891 222.881 35.6297 217.943 35.6297C213.005 35.6297 210.678 36.9918 210.678 39.0351C210.678 41.1351 212.892 41.4188 219.419 42.2134C227.422 43.1783 234.176 44.1432 234.176 51.0675C234.176 57.7648 227.195 60.9999 219.646 60.9999C212.041 60.9999 205.514 58.5026 202.222 54.0756Z"
        fill="currentColor"
      />
      <path
        d="M177.807 19C191.031 19 201.021 27.9108 201.021 40C201.021 52.0892 191.031 61 177.807 61C164.526 61 154.594 52.0892 154.594 40C154.594 27.9108 164.526 19 177.807 19ZM177.807 25.4135C168.442 25.4135 161.972 31.3162 161.972 40C161.972 48.6838 168.442 54.5865 177.807 54.5865C187.115 54.5865 193.585 48.6838 193.585 40C193.585 31.3162 187.115 25.4135 177.807 25.4135Z"
        fill="currentColor"
      />
      <path
        d="M118.286 43.008L112.951 41.1918L115.562 19.6243H149.049V25.981H121.011L119.705 35.9702C122.316 34.4378 126.743 32.7351 132.93 32.7351C143.997 32.7351 152.511 38.127 152.511 46.6972C152.511 55.3242 143.6 60.9999 131.795 60.9999C120.33 60.9999 112.043 56.0621 110 48.5702L116.414 45.7891C118.627 51.8053 123.962 54.8702 131.851 54.8702C139.286 54.8702 145.132 52.0891 145.132 46.8107C145.132 41.8161 139.57 38.7513 131.454 38.7513C125.665 38.7513 121.408 40.5675 118.286 43.008Z"
        fill="currentColor"
      />
      <path
        d="M40 40C17.9086 40 1.5722e-06 22.0914 1.5722e-06 0H10.8108C10.8108 16.1207 23.8793 29.1892 40 29.1892V40Z"
        fill="currentColor"
      />
      <path
        d="M40 40C62.0914 40 80 57.9086 80 80H69.1892C69.1892 63.8793 56.1207 50.8108 40 50.8108L40 40Z"
        fill="currentColor"
      />
      <path
        d="M9.45111e-07 40C22.0914 40 40 57.9086 40 80H29.1892C29.1892 63.8793 16.1207 50.8108 0 50.8108L9.45111e-07 40Z"
        fill="currentColor"
      />
      <path
        d="M80 40C57.9086 40 40 22.0914 40 0H50.8108C50.8108 16.1207 63.8792 29.1892 80 29.1892V40Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
